<template>
  <qx-card-form title="收款信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="receiver" slot-scope="prop">
        <ChooseReceiver
          ref="chooseReceiver"
          :isRadio="true"
          v-model="prop.form.receiver"
          @change="handleReceiverChange"
          :otherSearchData="{
            billId,
            userType,
          }"
          :fnRadioDisabled="
            (item) => {
              let disabled = false;
              if ($route.query.vehicleFeeType === '1') {
                if (item.userType !== 1) {
                  disabled = true;
                }
              }
              if ($route.query.vehicleFeeType === '2') {
                if (item.userType !== 3) {
                  disabled = true;
                }
              }
              return disabled;
            }
          "
        />
      </section>
      <section slot="selectedLIds" slot-scope="prop">
        <ChooseDeduct
          :acUserId="acUserId"
          v-model="prop.form.selectedLIds"
          @change="handleDeductChange"
        />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  mapState,
} from 'vuex';
import {
  deductList,
} from 'api/cost';
import { getReceiverList } from 'api';
import ChooseReceiver from 'components/choose/receiver';
import ChooseDeduct from 'components/chooseDeduct/chooseDeduct';
export default {
  components: {
    ChooseReceiver,
    ChooseDeduct,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
    userType () {
      let selectUserType = '';
      if (this.$route.query.vehicleFeeType === '1') {
        // 只能选择员工
        selectUserType = '1';
      } else if (this.$route.query.vehicleFeeType === '2') {
        // 只能选择司机
        selectUserType = '3';
      }
      return selectUserType;
    },
  },
  data () {
    return {
      acUserId: '',
      billId: '',
      otherFormData: {
        deductAmount: '', // 抵扣金额
        userType: '',
      },
      baseForm: {
        orgIdOptions: [],
        form: [
          {
            label: '收款人',
            value: 'receiver',
            default: {},
            slot: true,
          },
          {
            label: '收款账户名',
            value: 'receUserName',
            type: 'input',
            disabled: true,
          },
          {
            label: '收款银行',
            value: 'receBankName',
            type: 'input',
            disabled: true,
          },
          {
            label: '收款账号',
            value: 'receBankNo',
            type: 'input',
            disabled: true,
          },
          {
            label: '抵扣借支',
            value: 'selectedLIds',
            slot: true,
            default: [],
            hide: true,
          },
          {
            label: '应付金额',
            value: 'shouldPayAmount',
            type: 'input',
            disabled: true,
            unit: '元',
          },
        ],
        rules: {
          receiver: [ // 收款人
            { required: true, message: '请选择收款人', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    handleDeductChange () { // 抵扣变化
      this.$emit('getOtherFormVal', {
        from: 'receipt',
        tar: 'baseForm',
      });
    },

    /**
     * @returns {void}
     * vehicleFeeType=1 时候，属于 报销费用，需做以下处理
     * 1、收款方缺省为申请人。
     * 2、选择收款人时，只能选择员工
     */
    handleVehicleFeeType () {
      if (this.$route.query.vehicleFeeType === '1') {
        // 新增状态，设置默认收款人为默认申请人
        if (!this.$route.query.id) {
          if (this.userInfo && this.userInfo.staffTFInfo && this.userInfo.staffTFInfo.mobilePhone) {
            this.selectReceiverList({
              serviceId: true,
              servicePhone: this.userInfo.staffTFInfo.mobilePhone,
            }, {
              userType: 1,
            });
          }
        }
      }
    },

    receiveData (tar, val) {
      const payAmt = val.payAmt || '0.00';
      const selectedLIds = this.$refs.baseForm.getVal('selectedLIds');
      if (payAmt > 0 && selectedLIds && selectedLIds.length > 0) {
        const deductAmount = selectedLIds.reduce((last, next) => ({ amount: last.amount + next.amount }), { amount: 0 });
        this.otherFormData.deductAmount = deductAmount.amount; // 抵扣金额
        this.$refs.baseForm.setVal('shouldPayAmount', payAmt - deductAmount.amount);
      } else {
        this.$refs.baseForm.setVal('shouldPayAmount', payAmt || 0);
      }
      this.billId = val.servicePhone;
      const receiver = this.$refs.baseForm.getVal('receiver');
      if ((receiver.receiverPhone && val.servicePhone) && receiver.receiverPhone !== val.servicePhone) {
        this.$refs.baseForm.setVal('receiver', {});
        this.handleReceiverChange();
      }
      this.$refs.baseForm.setVal('selectedLIds', []);
      this.handleDeductChange();
      this.selectReceiverList(val);
    },
    // 自动查询收款人信息，并填写上
    async selectReceiverList (item, otherParams = {}) {
      if (item.serviceId) {
        const data = await getReceiverList({
          billId: item.servicePhone,
          // receiverMan: item.serviceName,
          ...otherParams,
          page: 1,
          rows: 20,
        });
        if (!data.failed) {
          if (data.items && data.items.length) {
            let isDefalut = null;
            data.items.some((item, index) => {
              if (item.isDefalutAcct === 1) {
                isDefalut = index;
                return true;
              }
            });

            if (isDefalut === null) {
              isDefalut = 0;
            }

            const receiver = {
              receiverName: data.items[isDefalut].receiverName || '',
              acctName: data.items[isDefalut].acctName || '',
              bankName: data.items[isDefalut].bankName || '',
              acctNo: data.items[isDefalut].acctNo || '',
              userType: data.items[isDefalut].userType || '',
              receUserType: data.items[isDefalut].receUserType || '',
              pinganCollectAcctId: data.items[isDefalut].pinganCollectAcctId || '',
              userId: data.items[isDefalut].userId || '',
              balanceType: data.items[isDefalut].balanceType || '',
              balanceTypeName: data.items[isDefalut].balanceTypeName || '',
              expireDate: data.items[isDefalut].expireDate ? this.formatDate(data.items[isDefalut].expireDate) : '',
            };

            this.otherFormData.userType = data.items[isDefalut].userType || '';
            this.$refs.baseForm.setVal('receiver', receiver);
          }
        }
        this.handleReceiverChange();
      } else if (!item.serviceName) {
        // 当重新选择服务商或者手动输入服务商时，清空收款人
        // if (this.$route.query.vehicleFeeType === '3') {
        //   this.$refs.baseForm.setVal('receiver', {});
        // }
        this.handleReceiverChange();
      }
    },

    handleReceiverChange () { // 收款人变化
      const receiver = this.$refs.baseForm.getVal('receiver');
      this.acUserId = String(receiver.userId);
      this.$refs.baseForm.setVal('receUserName', receiver.receiverName);
      this.$refs.baseForm.setVal('receBankName', receiver.bankName);
      this.$refs.baseForm.setVal('receBankNo', receiver.acctNo);
      this.$refs.baseForm.setVal('selectedLIds', []);
      this.otherFormData.userType = receiver.userType;
      if (Number(this.$route.query.vehicleFeeType) === 1) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: !receiver.userId,
          names: ['selectedLIds'],
        });
      }
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.receiver) {
          formData.receName = formData.receiver.receiverName; // 收款方名称
          formData.receUserName = formData.receiver.acctName; // 收款账户名
          formData.receBankName = formData.receiver.bankName; // 收款方银行
          formData.receBankNo = formData.receiver.acctNo; // 收款方银行卡号
          formData.receAccNo = formData.receiver.pinganCollectAcctId; // 收款方账户
          formData.userType = this.otherFormData.userType || ''; // 收款方类型
          formData.receUserType = formData.receiver.receUserType; // 收款方类型
          formData.receUserId = formData.receiver.userId; // 收款方ID
          formData.balanceType = formData.receiver.balanceType; // 结算方式
          formData.expireDate = this.formatDate(formData.receiver.expireDate || new Date()); // 到期时间
          delete formData.receiver;
        }
        formData.deductAmount = this.otherFormData.deductAmount;
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData(true);
      if (formData) {
        formData.selectedLIds = JSON.stringify(formData.selectedLIds.map((item) => ({
          LId: item.LId,
          deductAmount: item.amount,
        })));
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData();
      if (res.selectedLIds) {
        res.selectedLIds = res.selectedLIds.map((item) => item.LId);
        res.selectedLIds = res.selectedLIds.join(',');
      }
      if (res.shouldPayAmount) {
        res.shouldPayAmount = res.shouldPayAmount * 100;
      }
      return res;
    },
    async init (data = {}) {
      if (data.receName) {
        data.receiver = {
          receiverName: data.receName, // 收款方名称
          acctName: data.receUserName, // 收款账户名
          bankName: data.receBankName, // 收款方银行
          acctNo: data.receBankNo, // 收款方银行卡号
          pinganCollectAcctId: data.receAccNo, // 收款方账户
          userType: data.userType,
          receUserType: data.receUserType, // 收款方类型
          userId: String(data.receUserId), // 收款方ID
          balanceType: data.balanceType, // 结算方式
        };
      } else {
        data.receiver = {};
      }
      this.acUserId = String(data.receUserId); // 收款人id
      if (data.selectedLIds && data.selectedLIds.length) {
        const LIds = String(data.selectedLIds).split(',');
        const amounts = [];
        const amountRes = await deductList({
          acUserId: this.acUserId,
          relBusiCode: data.busiCode,
        });
        amountRes.items.forEach((item) => {
          if (LIds.indexOf(String(item.LId)) !== -1) {
            amounts.push(item.amount);
          }
        });
        data.selectedLIds = LIds.map((LId, index) => ({
          LId,
          amount: amounts[index],
        }));
      } else {
        data.selectedLIds = [];
      }
      if (data.shouldPayAmount) {
        data.shouldPayAmount = data.shouldPayAmount / 100;
      }
      this.$refs.baseForm.setVal('form', data);
      this.setFormVal(this.otherFormData, data);
      this.handleReceiverChange();
      this.handleVehicleFeeType();
      // 抵扣借支只有报销的时候才会显示
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !(Number(this.$route.query.vehicleFeeType) === 1),
        names: ['selectedLIds'],
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
